import { services } from '../../../../api';
import { PatientListResponse } from '../../../../interfaces/api/patients';

/**
 * Fetch patients list with paging
 * @param {number} page - Page number (1-based)
 * @param {number} pageSize - Number of items per page
 * @returns {Promise<PatientListResponse | null>} API response or null on error
 */
export const fetchPatients = async (page: number, pageSize: number): Promise<PatientListResponse | null> => {
  try {
    const res = await services.patients.getPatients(page, pageSize);
    return res;
  } catch (error) {
    return null;
  }
}; 